import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const MerchantsShowLimitsEditDialogFormSkeleton: React.FC = () => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
    </Box>
  );
};
